import React, { useState, createContext, useContext, ReactNode, useEffect } from "react";
const HeaderMenu = createContext<any>({});
interface AddressData {
  firstName?: string;
  lastName?: string;
  line1?: string;
  line2?: string;
  city?: string;
  postalCode?: string;
  country?: string;
  countrySubdivision?: string;
  countryName?: string;
  emailAddress?: string;
}
interface iOrderDetails {
  cart: { billingAddress?: AddressData; shippingAddress?: AddressData | null; shippingMethod?: string; paymentOption?: { [key: string]: any }; taxExemption?: object | null; };
}
export default function LoginWrapper({
  children,
}: {
  children?: ReactNode;
}) {
  const [loginStatus, setLoginStatus] = useState<any>();
  const [itemsInCart, setItemsInCart] = useState<any>();
  const [brand, setBrand] = useState<string>("");
  const [isThanks, setIsThanks] = useState<boolean>(false);
  const [orderFlag, setOrderFlag] = useState<boolean>(false);
  const [order, setOrder] = useState<iOrderDetails>();
  const [deviceFingerprintUuid, setDeviceFingerprintUuid] = useState<string | null>(null);
  const value = {
    order,
    setOrder,
    itemsInCart,
    setItemsInCart,
    loginStatus,
    setLoginStatus,
    orderFlag,
    setOrderFlag,
    isThanks,
    setIsThanks,
    brand,
    setBrand,
    deviceFingerprintUuid,
    setDeviceFingerprintUuid
  };
  useEffect(() => {
    setItemsInCart(value.itemsInCart);
  }, [itemsInCart, value.itemsInCart]);
  return (<HeaderMenu.Provider value={value}> {children} </HeaderMenu.Provider>);
}

export function useHeaderMenu() {
  return useContext(HeaderMenu);
}